import { useState } from "react";
import ForgotPassword from "./forgot_password";
import Not_Registerd_Yet from "./not_registered_yet";
import Login from "./login";

const LoginForm = ({ handleClosePopup }) => {
  const [forgotPass, setForgotPass] = useState(false);
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-[1000000]">
      <div className="relative bg-[#363435] text-center mx-5 p-8 w-full max-w-[600px] lg:max-w-[43vw] z-[99]">
        {/* Cross icon for closing the popup */}
        <button
          className="close-popup-icon absolute top-[0px] right-[5px] !text-[30px] !text-[#fff] leading-[1] focus:outline-none !cursor-pointer"
          onClick={() => handleClosePopup("mobileNoPopup")}
        >
          &times; {/*This represents the "X" character*/}
        </button>
        <form>
          <div className="md:grid *:mb-5 text-start !cursor-auto">
            {!forgotPass && <Login setForgotPass={setForgotPass} />}
            {forgotPass && <ForgotPassword setForgotPass={setForgotPass} />}
            <hr />
            {!forgotPass && (
              <Not_Registerd_Yet handleClosePopup={handleClosePopup} />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
